import { BaseChart } from "./baseChart";
import { MinMaxT } from "./types";

export class CagrChart extends BaseChart {
  getDefaultAxisMinMax(): MinMaxT {
    return {
      xMin: "2000",
      xMax: null,
      yMin: -50,
      yMax: 100
    };
  }

  getDefaultAxis(sessionMinMax?: MinMaxT): MinMaxT {
    const defaultMinMax = this.getDefaultAxisMinMax();
    if (!sessionMinMax) {
      return defaultMinMax;
    }
    const yMax = !isNaN(parseFloat(sessionMinMax?.yMax?.toString()))
      ? parseFloat(sessionMinMax?.yMax?.toString())
      : defaultMinMax.yMax;
    const yMin = !isNaN(parseFloat(sessionMinMax?.yMin?.toString()))
      ? parseFloat(sessionMinMax?.yMin?.toString())
      : defaultMinMax.yMin;
    const xMax = sessionMinMax?.xMax ?? defaultMinMax.xMax;
    const xMin = sessionMinMax?.xMin ?? defaultMinMax.xMin;
    return {
      xMin,
      xMax,
      yMin,
      yMax
    };
  }
}
